module.exports = __webpack_public_path__ + "static/media/wide-arrow-down.ef0642be.png";